import { BaseEntity, Entity as DecribeEntity, RelationList } from '@avangard/utils/entity';

import { StudentProfileItemEntity } from './student-profile-item.entity';
import { StudentProfileItemEntityList } from './student-profile-item.entity-list';

import type { ProfileSection } from '@modules/types/graphql';

export type Entity = Partial<ProfileSection> | null;

@DecribeEntity('StudentProfileSectionEntity')
class StudentProfileSectionEntity extends BaseEntity {
    name: string;

    @RelationList(() => StudentProfileItemEntityList)
    items: StudentProfileItemEntity[];

    constructor(studentProfileSection: Entity) {
        super(studentProfileSection);

        this.name = studentProfileSection?.name ?? '';
    }
}

export { StudentProfileSectionEntity };
